module.exports = __webpack_public_path__ + "SikanderManshahia-d1a3edfa.webp";